import { render, staticRenderFns } from "./Shan3.vue?vue&type=template&id=61a7f281&"
import script from "./Shan3.vue?vue&type=script&lang=js&"
export * from "./Shan3.vue?vue&type=script&lang=js&"
import style0 from "./Shan3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports